import axios from 'axios'
import axiosConfig from '../axios-config'

import { createRouter, createWebHistory } from 'vue-router'

import MainLayout from '../views/MainLayout.vue'
import HomeView from '../views/Home';
import Login from '../views/auth/Login'
import Error404 from '../views/error/404'

import FormPublic from '../views/formularios/Form'
import FormPublicFinalized from '../views/formularios/FormFinalized'
import Companies from '../views/companies/Companies'
import Usuario from '../views/usuario/Usuario'

import IndexUsuario from '../components/usuarios/Index'
import ListUsuario from '../components/usuarios/index/ListUsuario'
import CreateUsuario from '../components/usuarios/Create'
import UpdateUsuario from '../components/usuarios/Edit'

// COMPANIES:
import IndexCompanies from '../components/companies/Index'
import ListCompanies from '../components/companies/index/ListCompanies'
import CreateCompany from '../components/companies/Create'
import EditCompany from '../components/companies/Edit'

// FORMULARIOS PUBLICOS:
import IndexFormsPublic from '../components/fomularios/Index'
import ListFormsPublic from '../components/fomularios/index/ListFormsPublic'

const routes = [
  { path: '/', name: 'Login', component: Login },
  
  { path: `/:slug/formularios/:id`, name: 'FormPublic', component: FormPublic },
  { path: `/:slug/formularios/:id/formulario-finalizado`, name: 'FormPublicFinalized', component: FormPublicFinalized },

  { path: '/404', name: 'NotFound', component: Error404 },
  { path: '/:catchAll(.*)', redirect: '/404' },
  
  { path: '/public', component: MainLayout, 
    children: [
      { path: '/home', name: 'HomeView', component: HomeView },
      { path: '/usuario', component: Usuario,
        children: [
          { path: 'index', name: 'IndexUsuario', component: IndexUsuario },
          { path: 'buscar-usuarios', name: 'ListUsuario', component: ListUsuario },
          { path: 'crear-usuario', name: 'CreateUsuario', component: CreateUsuario },
          { path: 'editar-usuario/:id', name: 'UpdateUsuario', component:  UpdateUsuario },
        ]
      },
      { path: '/admin', component: Companies,
        children: [
          { path: 'index', name: 'IndexCompanies', component: IndexCompanies },
          { path: 'empresas', name: 'ListCompanies', component: ListCompanies },
          { path: 'crear-empresa', name: 'CreateCompany', component: CreateCompany },
          { path: 'editar-empresa/:id', name: 'EditCompany', component: EditCompany },
        ]
      },
      { path: '/formularios', component: Companies,
        children: [
          { path: 'index', name: 'IndexFormsPublic', component: IndexFormsPublic },
          { path: 'public', name: 'ListFormsPublic', component: ListFormsPublic },
        ]
      },
    ]
  },
];

const router = createRouter({
  history: createWebHistory(`${process.env.VUE_APP_WEB_HISTORY_FRONTEND}`),
  base: `${process.env.VUE_APP_BASE_FRONTEND}`,
  routes
})

if (process.env.NODE_ENV === 'development') {
  router.mode = 'hash';
}

router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem('token');
  const rol = localStorage.getItem('rol');
  
  // VERIFICAMOS SI LA RUTA ES PUBLICA
  if (to.name === 'FormPublic' || to.name === 'FormPublicFinalized') {
    next();
  } else {
    if (!token && to.name !== 'Login') {
      next({ name: 'Login' });
    } else if (!axios.defaults.headers.common['Authorization'] && token) {
      axiosConfig(token);
    } else {
      next();
    }
  }
});


export default router;